var SupportGiftOrderPopupView, SupportGiftOrderServiceActionView, SupportServiceActionButtonTemplate, SupportServiceActionsBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportGiftOrderPopupView = require('../gift_order_popup_view');

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportGiftOrderServiceActionView = (function(superClass) {
  extend(SupportGiftOrderServiceActionView, superClass);

  function SupportGiftOrderServiceActionView() {
    return SupportGiftOrderServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportGiftOrderServiceActionView.prototype.id = 'gift_to_friend';

  SupportGiftOrderServiceActionView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    this.order = Groupon.Support.currentOrder;
    return this.attributes = this.options.userId;
  };

  SupportGiftOrderServiceActionView.prototype.render = function() {
    var hash;
    return hash = this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportGiftOrderServiceActionView.prototype.toHash = function() {
    var hash;
    hash = {
      service_action_id: "gift_order",
      service_action: I18n.t("js.modules.support.gift_order")
    };
    return this.extendHash(hash);
  };

  SupportGiftOrderServiceActionView.prototype.actionHandler = function(event) {
    var current_order, dealPermalink, orderId, url;
    current_order = Groupon.Support.currentOrder;
    dealPermalink = current_order.deal.id;
    orderId = current_order.id;
    url = "/deals/" + dealPermalink + "/confirmation?pledge_id=" + current_order.dealOptionId;
    window.open(url);
    return this.popup = new SupportGiftOrderPopupView();
  };

  SupportGiftOrderServiceActionView.prototype.events = {
    "click #gift_order": "actionHandler"
  };

  return SupportGiftOrderServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportGiftOrderServiceActionView;

//# sourceMappingURL=data:application/json;base64,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
